import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAuthorization } from '../../stores/authorization';
export const AuthorizedGate = ({ permissions, children, showToast = false }) => {
    const { checkPermissions } = useAuthorization();
    if (!checkPermissions(permissions)) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
